export default "__VITE_ASSET__CRt5h3VA__"